import { Button, Flex, Modal, ModalBody, ModalContent, ModalFooter, ModalHeader, ModalOverlay, Text, VStack } from '@chakra-ui/react'
import { useLazyQuery } from '@apollo/client'
import { GET_GLUCOSE_REPORT } from 'queries/reportQueries'
import { downloadBinaryReport } from 'functions/reports'
import { DownloadIcon } from '@phosphor-icons/react'

interface Props {
    isOpen: boolean
    onClose: () => void
}

const ExportData = ({ isOpen, onClose }: Props) => {
    const [getReport, { loading: loadingReport }] = useLazyQuery(GET_GLUCOSE_REPORT, {
        fetchPolicy: 'no-cache'
    });

    const onDownload = async (withDateLimit: boolean) => {
        const { data: reportData } = await getReport({
            variables: {
                withDateLimit
            }
        });
        const report = reportData.getGlucoseReport;

        const filename = report.filename;
        const content = report.content;

        downloadBinaryReport(filename, content)
    }

    return (
        <Modal isOpen={isOpen} onClose={onClose} isCentered>
            <ModalOverlay />
            <ModalContent>
                <ModalHeader>
                    <Text>Exportar Dados de Glicemia</Text>
                </ModalHeader>
                <ModalBody>
                    <Flex alignItems="center" w="full" h="full" mb={6} direction="column" >
                        <Text mb={4}>Escolha quais dados deseja Exportar</Text>
                        <VStack>
                            <Button colorScheme='green' onClick={() => onDownload(false)} isLoading={loadingReport} leftIcon={<DownloadIcon weight="bold" />} >Exportar todos Dados</Button>
                            <Text>ou</Text>
                            <Button colorScheme='green' onClick={() => onDownload(true)} isLoading={loadingReport} leftIcon={<DownloadIcon weight="bold" />} >Exportar Dados da semana</Button>
                        </VStack>
                    </Flex>
                </ModalBody>
                <ModalFooter gap={2}>
                    <Button colorScheme="red" onClick={onClose} >Fechar</Button>
                </ModalFooter>
            </ModalContent>
        </Modal>
    )
}

export default ExportData